import { format, zonedTimeToUtc } from "date-fns-tz";
import { isValid } from "./evaluations.js";

export const processTransformations = (
  transformations,
  model,
  interpreterItems
) => {
  if (transformations)
    transformations.forEach((transformation) => {
      switch (transformation.fn) {
        case "substr": //copy part from source to target
          model = substring(transformation, model, interpreterItems);
          break;
        case "copy":
          model = copy(transformation, model);
          break;
        case "copyIfEmpty":
          model = copyIfEmpty(transformation, model);
          break;
        case "setConst":
          model[transformation.target] = transformation.value;
          break;
        case "concat":
          model = concat(transformation, model);
          break;
        case "emptyToNull":
          model = emptyToNull(transformation, model);
          break;
        case "parseDate":
          model = parseDate(transformation, model);
          break;
        case "when":
          model = when(transformation, model);
          break;
        default:
      }
    });

  return model;
};

const getFieldDefintionByName = function (name, interpreterItems) {
  return Object.entries(interpreterItems).find(
    ([key, item]) => item["name"] === name
  );
};

const substring = (transformation, model, interpreterItems) => {
  const source = getFieldDefintionByName(
    transformation["source"],
    interpreterItems
  );
  if (isValid(source, model, interpreterItems)) {
    const tsource = model[transformation.source];
    if (tsource !== undefined && tsource !== null)
      model[transformation.target] = tsource.substr(
        transformation.start,
        transformation.end
      );
  }
  return model;
};

const copy = (transformation, model) => {
  model[transformation.target] = readSourceValue(transformation, model);
  return model;
};

const copyIfEmpty = (transformation, model) => {
  if (model[transformation.target] === "") {
    model[transformation.target] = readSourceValue(transformation, model);
  }

  return model;
};

const readSourceValue = (transformation, model) => {
  const objPath = transformation.source.split(".");
  let resultValue = model;
  objPath.forEach((item) => {
    if (resultValue) resultValue = resultValue[item];
  });
  return resultValue;
};

const emptyToNull = (transformation, model) => {
  let value = model[transformation.source];
  if (value === "") value = null;
  model[transformation.target] = value;
  return model;
};

const parseDate = (transformation, model) => {
  let value = model[transformation.field];
  if (value === "") {
    value = null;
    model[transformation.field] = null;
  }
  if (!isNaN(Date.parse(value)))
    model[transformation.field] = format(
      zonedTimeToUtc(new Date(value), "Europe/Berlin"),
      "yyyy-MM-dd"
    );
  return model;
};

const when = (transformation, model) => {
  if (model[transformation.source] === transformation.compare) {
    model[transformation.target] = transformation.value;
  }
  return model;
};

const concat = (transformation, model) => {
  let result = "";
  let error = false;
  transformation.parts.forEach((item) => {
    let tmpResult = null;
    switch (item.fn) {
      case "field":
        tmpResult = model[item.param];
        break;
      case "const":
        tmpResult = item.param;
        break;
      case "datetime":
        tmpResult = format(new Date(), item.param);
        break;
      default:
    }
    if (tmpResult === null || tmpResult === undefined) error = true;
    result += tmpResult;
  });
  if (error) result = "";
  model[transformation.target] = result;
  return model;
};
